<template>
  <div style="font-size: 13px">
    <b-navbar toggleable="lg" type="dark" variant="success">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <div class="logo"></div>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(FUEL_TANKS_READ_ROLE) !=
              -1
            "
            @click="selectComponent('fuelTanks')"
            v-bind:class="{ active: isFuelTanksShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.fuelTanksLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(REPORTS_READ_ROLE) !=
                -1 ||
              $store.state.authentication.roles.indexOf(
                REPORTS_ACCOUNTING_SYSTEM_READ_ROLE
              ) != -1 ||
              $store.state.authentication.roles.indexOf(
                REPORTS_LIMITED_READ_ROLE
              ) != -1
            "
            @click="selectComponent('reports')"
            v-bind:class="{ active: isFuelReportsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.reportsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(CHARTS_READ_ROLE) !=
                -1 ||
              $store.state.authentication.roles.indexOf(
                CHARTS_ACCOUNTING_SYSTEM_READ_ROLE
              ) != -1 ||
              $store.state.authentication.roles.indexOf(
                CHARTS_LIMITED_READ_ROLE
              ) != -1
            "
            @click="selectComponent('charts')"
            v-bind:class="{ active: isChartsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.chartsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(
                TAX_REPORTS_READ_ROLE
              ) != -1
            "
            @click="selectComponent('taxReports')"
            v-bind:class="{ active: isTaxReportsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.taxReportsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(SUPER_ADMIN_ROLE) !=
                -1 ||
              $store.state.authentication.roles.indexOf(ADMIN_ROLE) != -1
            "
            @click="selectComponent('users')"
            v-bind:class="{ active: isUsersShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.usersLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(DRIVERS_READ_ROLE) != -1
            "
            @click="selectComponent('drivers')"
            v-bind:class="{ active: isDriversShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.driversLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(COUPONS_READ_ROLE) != -1
            "
            @click="selectComponent('coupons')"
            v-bind:class="{ active: isCouponsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.couponsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(LIMITS_READ_ROLE) != -1
            "
            @click="selectComponent('limits')"
            v-bind:class="{ active: isLimitsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.limitsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(CLIENTS_READ_ROLE) != -1
            "
            @click="selectComponent('clients')"
            v-bind:class="{ active: isClientsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.clientsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(SCFG_USERS_READ_ROLE) != -1
            "
            @click="selectComponent('scfgUsers')"
            v-bind:class="{ active: isScfgUsersShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.scfgUsersLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(SUPER_ADMIN_ROLE) != -1 
            "
            @click="selectComponent('logs')"
            v-bind:class="{ active: isLogsShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.logsLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item
            v-if="
              $store.state.authentication.roles.indexOf(AZK_GET_DATA) != -1 
            "
            @click="selectComponent('azk')"
            v-bind:class="{ active: isAzkShow }"
            style="font-weight: bold"
            >{{
              $store.state.localization.data.mainPage.azkLabel
            }}</b-nav-item
          >
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item
            v-if="config.telegram.enabled"
            v-bind:href="$store.state.authentication.telegramUrl"
            target="_blank"
            style="font-weight: bold"
          >
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 256 256"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              preserveAspectRatio="xMidYMid"
            >
              <g>
                <path
                  d="M128,0 C57.307,0 0,57.307 0,128 L0,128 C0,198.693 57.307,256 128,256 L128,256 C198.693,256 256,198.693 256,128 L256,128 C256,57.307 198.693,0 128,0 L128,0 Z"
                  fill="#40B3E0"
                ></path>
                <path
                  d="M190.2826,73.6308 L167.4206,188.8978 C167.4206,188.8978 164.2236,196.8918 155.4306,193.0548 L102.6726,152.6068 L83.4886,143.3348 L51.1946,132.4628 C51.1946,132.4628 46.2386,130.7048 45.7586,126.8678 C45.2796,123.0308 51.3546,120.9528 51.3546,120.9528 L179.7306,70.5928 C179.7306,70.5928 190.2826,65.9568 190.2826,73.6308"
                  fill="#FFFFFF"
                ></path>
                <path
                  d="M98.6178,187.6035 C98.6178,187.6035 97.0778,187.4595 95.1588,181.3835 C93.2408,175.3085 83.4888,143.3345 83.4888,143.3345 L161.0258,94.0945 C161.0258,94.0945 165.5028,91.3765 165.3428,94.0945 C165.3428,94.0945 166.1418,94.5735 163.7438,96.8115 C161.3458,99.0505 102.8328,151.6475 102.8328,151.6475"
                  fill="#D2E5F1"
                ></path>
                <path
                  d="M122.9015,168.1154 L102.0335,187.1414 C102.0335,187.1414 100.4025,188.3794 98.6175,187.6034 L102.6135,152.2624"
                  fill="#B5CFE4"
                ></path>
              </g>
            </svg>
            TelegramBot</b-nav-item
          >
          <b-nav-item
            v-if="config.viber.enabled"
            v-bind:href="$store.state.authentication.viberUrl"
            target="_blank"
            style="font-weight: bold"
          >
            <svg
              version="1.1"
              id="Layer_1"
              width="20px"
              height="20px"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <circle style="fill: #6f3faa" cx="256" cy="256" r="256" />
              <path
                style="fill: #512d84"
                d="M367.061,140.443c-62.312-15.05-124.735-32.654-188.637-10.288
	c-41.374,15.515-41.374,60.337-39.65,98.263c0,10.343-12.067,24.135-6.896,36.202c10.343,34.478,18.963,68.956,55.165,86.195
	c5.172,3.448,0,10.343,3.448,15.515c-1.724,0-5.172,1.724-5.172,3.448c0,8.263,3.708,20.902,1.245,29.05L296.57,508.788
	c113.09-18.01,201.478-110.068,213.914-224.921L367.061,140.443z"
              />
              <g>
                <path
                  style="fill: #ffffff"
                  d="M391.427,179.924l-0.084-0.338c-6.84-27.653-37.678-57.325-65.998-63.498l-0.319-0.066
		c-45.806-8.738-92.251-8.738-138.047,0l-0.329,0.066c-28.31,6.173-59.149,35.847-65.998,63.498l-0.076,0.338
		c-8.456,38.617-8.456,77.781,0,116.398l0.076,0.338c6.558,26.472,35.099,54.782,62.362,62.567v30.868
		c0,11.173,13.615,16.66,21.357,8.597l31.275-32.509c6.784,0.379,13.571,0.591,20.356,0.591c23.057,0,46.125-2.181,69.023-6.549
		l0.319-0.066c28.32-6.173,59.158-35.847,65.998-63.498l0.084-0.338C399.882,257.705,399.882,218.543,391.427,179.924z
		M366.676,290.723c-4.567,18.041-27.981,40.469-46.585,44.613c-24.355,4.632-48.904,6.611-73.428,5.932
		c-0.488-0.014-0.957,0.176-1.296,0.526c-3.481,3.572-22.835,23.442-22.835,23.442l-24.288,24.928
		c-1.776,1.852-4.896,0.591-4.896-1.964v-51.136c0-0.845-0.603-1.562-1.433-1.726c-0.005-0.002-0.009-0.002-0.014-0.003
		c-18.604-4.144-42.01-26.572-46.585-44.613c-7.611-34.906-7.611-70.292,0-105.198c4.575-18.041,27.981-40.469,46.585-44.613
		c42.536-8.09,85.664-8.09,128.191,0c18.613,4.144,42.018,26.572,46.585,44.613C374.296,220.431,374.296,255.817,366.676,290.723z"
                />
                <path
                  style="fill: #ffffff"
                  d="M296.47,314.327c-2.86-0.869-5.585-1.452-8.118-2.501c-26.231-10.883-50.371-24.923-69.492-46.444
		c-10.874-12.238-19.385-26.055-26.579-40.677c-3.412-6.934-6.287-14.139-9.218-21.299c-2.672-6.528,1.264-13.272,5.408-18.192
		c3.889-4.617,8.894-8.149,14.314-10.754c4.23-2.032,8.402-0.86,11.492,2.725c6.678,7.752,12.814,15.9,17.78,24.886
		c3.055,5.527,2.217,12.283-3.32,16.044c-1.346,0.914-2.572,1.988-3.825,3.02c-1.1,0.905-2.134,1.819-2.888,3.044
		c-1.377,2.241-1.443,4.886-0.557,7.323c6.827,18.761,18.334,33.351,37.219,41.21c3.022,1.257,6.056,2.72,9.538,2.315
		c5.83-0.681,7.718-7.077,11.804-10.418c3.993-3.265,9.097-3.308,13.398-0.586c4.303,2.724,8.473,5.646,12.619,8.601
		c4.07,2.9,8.121,5.735,11.874,9.042c3.61,3.179,4.853,7.349,2.82,11.662c-3.72,7.901-9.135,14.472-16.944,18.668
		C301.59,313.178,298.956,313.561,296.47,314.327C293.61,313.458,298.956,313.561,296.47,314.327z"
                />
                <path
                  style="fill: #ffffff"
                  d="M256.071,165.426c34.309,0.962,62.49,23.731,68.529,57.651c1.029,5.78,1.395,11.688,1.853,17.555
		c0.193,2.467-1.205,4.811-3.867,4.844c-2.75,0.033-3.987-2.269-4.167-4.734c-0.353-4.882-0.598-9.787-1.271-14.627
		c-3.551-25.559-23.931-46.704-49.371-51.241c-3.829-0.683-7.745-0.862-11.624-1.269c-2.451-0.257-5.661-0.405-6.204-3.453
		c-0.455-2.555,1.701-4.589,4.134-4.72C254.742,165.393,255.407,165.424,256.071,165.426
		C290.382,166.388,255.407,165.424,256.071,165.426z"
                />
                <path
                  style="fill: #ffffff"
                  d="M308.212,233.019c-0.057,0.429-0.086,1.436-0.338,2.384c-0.91,3.444-6.134,3.875-7.335,0.4
		c-0.357-1.031-0.41-2.205-0.412-3.315c-0.012-7.266-1.591-14.526-5.256-20.849c-3.767-6.499-9.523-11.96-16.272-15.267
		c-4.082-1.998-8.495-3.241-12.969-3.98c-1.955-0.324-3.931-0.519-5.896-0.793c-2.381-0.331-3.653-1.848-3.539-4.194
		c0.105-2.198,1.712-3.781,4.108-3.644c7.873,0.446,15.479,2.15,22.48,5.856c14.234,7.539,22.366,19.437,24.74,35.326
		c0.107,0.721,0.279,1.433,0.334,2.155C307.991,228.88,308.076,230.665,308.212,233.019
		C308.155,233.446,308.076,230.665,308.212,233.019z"
                />
                <path
                  style="fill: #ffffff"
                  d="M286.872,232.188c-2.87,0.052-4.406-1.538-4.703-4.168c-0.205-1.834-0.369-3.694-0.807-5.48
		c-0.862-3.517-2.731-6.775-5.689-8.93c-1.396-1.017-2.979-1.758-4.636-2.238c-2.105-0.609-4.293-0.441-6.392-0.955
		c-2.281-0.559-3.543-2.407-3.184-4.546c0.326-1.948,2.22-3.468,4.349-3.313c13.302,0.96,22.809,7.837,24.166,23.497
		c0.097,1.105,0.209,2.272-0.036,3.331C289.518,231.193,288.178,232.1,286.872,232.188
		C284.001,232.239,288.178,232.1,286.872,232.188z"
                />
              </g>
              <path
                style="fill: #d1d1d1"
                d="M391.427,179.924l-0.084-0.338c-3.834-15.501-15.212-31.635-29.458-43.911l-19.259,17.068
	c11.452,9.125,21.264,21.766,24.052,32.78c7.62,34.907,7.62,70.292,0,105.2c-4.567,18.041-27.982,40.469-46.585,44.613
	c-24.355,4.632-48.904,6.611-73.428,5.932c-0.488-0.014-0.957,0.176-1.296,0.526c-3.481,3.572-22.835,23.442-22.835,23.442
	l-24.288,24.928c-1.776,1.852-4.896,0.593-4.896-1.964v-51.136c0-0.845-0.603-1.562-1.433-1.726c-0.005,0-0.009-0.002-0.014-0.002
	c-10.573-2.355-22.692-10.618-32.028-20.621l-19.03,16.863c11.885,12.929,27.214,23.381,42.168,27.651v30.868
	c0,11.173,13.615,16.66,21.357,8.597l31.275-32.509c6.784,0.379,13.569,0.591,20.356,0.591c23.057,0,46.125-2.181,69.023-6.549
	l0.319-0.065c28.32-6.173,59.158-35.845,65.998-63.498l0.084-0.338C399.882,257.705,399.882,218.543,391.427,179.924z"
              />
              <path
                style="fill: #ffffff"
                d="M296.47,314.327C298.956,313.561,293.61,313.458,296.47,314.327L296.47,314.327z"
              />
              <path
                style="fill: #d1d1d1"
                d="M317.921,281.664c-3.753-3.305-7.806-6.142-11.874-9.042c-4.146-2.955-8.316-5.877-12.619-8.601
	c-4.301-2.722-9.404-2.679-13.398,0.586c-4.086,3.341-5.973,9.737-11.804,10.418c-3.481,0.405-6.516-1.059-9.538-2.315
	c-11.619-4.834-20.435-12.226-27.098-21.559l-14.16,12.55c0.481,0.557,0.94,1.129,1.429,1.679
	c19.122,21.521,43.263,35.561,69.492,46.444c2.531,1.05,5.258,1.634,8.118,2.501c-2.86-0.869,2.488-0.765,0,0
	c2.488-0.765,5.12-1.15,7.327-2.332c7.811-4.196,13.224-10.768,16.944-18.668C322.774,289.013,321.531,284.843,317.921,281.664z"
              />
              <g>
                <path
                  style="fill: #ffffff"
                  d="M256.159,165.431c-0.029,0-0.057-0.003-0.086-0.003
		C256.045,165.426,256.081,165.428,256.159,165.431z"
                />
                <path
                  style="fill: #ffffff"
                  d="M256.072,165.426c0.029,0,0.057,0.003,0.086,0.003C258.062,165.497,289.03,166.35,256.072,165.426z"
                />
              </g>
              <g>
                <path
                  style="fill: #d1d1d1"
                  d="M305.285,185.837l-6.037,5.351c9.487,9.23,16.029,21.463,17.899,34.925
		c0.672,4.842,0.919,9.745,1.272,14.627c0.179,2.467,1.415,4.768,4.167,4.736c2.663-0.033,4.06-2.376,3.867-4.844
		c-0.459-5.866-0.824-11.776-1.853-17.555C321.957,208.229,315.07,195.518,305.285,185.837z"
                />
                <path
                  style="fill: #d1d1d1"
                  d="M307.521,224.939c-1.729-11.578-6.532-21.026-14.51-28.224l-6.02,5.335
		c3.113,2.763,5.806,6.008,7.88,9.587c3.665,6.323,5.244,13.583,5.256,20.849c0.002,1.11,0.055,2.284,0.412,3.317
		c1.203,3.477,6.425,3.046,7.335-0.4c0.252-0.95,0.281-1.957,0.338-2.384c-0.057,0.429-0.138-2.353,0,0
		c-0.138-2.353-0.222-4.139-0.357-5.923C307.802,226.371,307.629,225.659,307.521,224.939z"
                />
              </g>
              <g>
                <path
                  style="fill: #ffffff"
                  d="M308.212,233.019C308.076,230.665,308.155,233.446,308.212,233.019L308.212,233.019z"
                />
                <path
                  style="fill: #ffffff"
                  d="M286.872,232.188c0.045-0.003,0.088-0.026,0.131-0.031c-0.121,0-0.307,0.003-0.498,0.01
		C286.629,232.17,286.742,232.189,286.872,232.188z"
                />
                <path
                  style="fill: #ffffff"
                  d="M286.872,232.188c-0.129,0.002-0.243-0.017-0.367-0.021
		C285.884,232.184,285.243,232.217,286.872,232.188z"
                />
                <path
                  style="fill: #ffffff"
                  d="M287.003,232.157c-0.045,0.005-0.088,0.028-0.131,0.031
		C287.208,232.165,287.179,232.157,287.003,232.157z"
                />
              </g>
              <path
                style="fill: #d1d1d1"
                d="M280.814,207.525l-6.128,5.432c0.338,0.205,0.669,0.419,0.99,0.652
	c2.958,2.155,4.827,5.413,5.689,8.93c0.438,1.786,0.6,3.644,0.807,5.48c0.283,2.513,1.71,4.058,4.336,4.148
	c0.191-0.005,0.379-0.009,0.498-0.01c1.264-0.14,2.531-1.026,2.936-2.774c0.245-1.057,0.133-2.226,0.036-3.331
	C289.216,217.297,285.906,211.29,280.814,207.525z"
              />
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
              <g></g>
            </svg>

            ViberBot</b-nav-item
          >
          <b-nav-item-dropdown
            v-bind:text="$store.state.localization.data.mainPage.langLabel"
            right
            style="font-weight: bold"
          >
            <b-dropdown-item
              @click="changeLocale('en')"
              href="#"
              style="font-size: 13px"
              >English</b-dropdown-item
            >
            <b-dropdown-item
              @click="changeLocale('ru')"
              href="#"
              style="font-size: 13px"
              >Русский</b-dropdown-item
            >
            <b-dropdown-item
              @click="changeLocale('ua')"
              href="#"
              style="font-size: 13px"
              >Українська</b-dropdown-item
            >
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            v-bind:text="$store.state.authentication.userName"
            right
            style="font-weight: bold"
          >
            <b-dropdown-item disabled style="font-size: 13px"
              >v: 174</b-dropdown-item
            >
            <b-dropdown-item
              @click="openUserSettings"
              href="#"
              style="font-size: 13px"
              >{{
                $store.state.localization.data.mainPage.user.profileLabel
              }}</b-dropdown-item
            >
            <b-dropdown-item
              style="font-size: 13px"
              href="/doc/NaviTrack-manual.pdf"
              target="_blank"
              >{{
                $store.state.localization.data.mainPage.user.manualLabel
              }}</b-dropdown-item
            >
            <b-dropdown-item @click="logout" href="#" style="font-size: 13px">{{
              $store.state.localization.data.mainPage.user.logoutLabel
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div>
      <FuelTanks v-show="isFuelTanksShow" v-bind:fuelTanks="fuelTanks" v-bind:fuelDepos="fuelDepos"></FuelTanks>
      <Reports v-show="isFuelReportsShow" v-bind:fuelTanks="fuelTanks"></Reports>
      <Charts v-show="isChartsShow" v-bind:fuelTanks="fuelTanks"></Charts>
      <TaxReports v-show="isTaxReportsShow" v-bind:fuelTanks="fuelTanks"></TaxReports>
      <Users v-show="isUsersShow" v-bind:fuelDepos="fuelDepos"></Users>
      <Logs v-show="isLogsShow"></Logs>
      <AZK v-show="isAzkShow" v-bind:fuelDepos="fuelDepos"></AZK>
      <Drivers
        v-if="
          $store.state.authentication.roles.indexOf(DRIVERS_READ_ROLE) != -1
        "
        v-show="isDriversShow"
        ref="drivers-page"
      ></Drivers>
      <Coupons
        v-if="
          $store.state.authentication.roles.indexOf(COUPONS_READ_ROLE) != -1
        "
        v-show="isCouponsShow"
      ></Coupons>
      <Limits
        v-if="
          $store.state.authentication.roles.indexOf(LIMITS_READ_ROLE) != -1
        "
        v-show="isLimitsShow"
      ></Limits>
      <Clients
        v-if="
          $store.state.authentication.roles.indexOf(CLIENTS_READ_ROLE) != -1
        "
        v-show="isClientsShow"
        ref="clients-page"
      ></Clients>
      <ScfgUsers
        v-if="
          $store.state.authentication.roles.indexOf(CLIENTS_READ_ROLE) != -1
        "
        v-show="isScfgUsersShow"
        ref="scfg-users-page"
      ></ScfgUsers>
    </div>
    <UserSettings ref="user-settings"></UserSettings>
  </div>
</template>

<script>
import FuelTanks from "./FuelTanks/FuelTanksMain/FuelTanksMain.vue";
import Reports from "./Reports/ListReports/Reports.vue";
import Charts from "./Charts/ListCharts/Charts.vue";
import TaxReports from "./TaxReports/TaxReports.vue";
import Users from "./Users/ListUsers/ListUsersPage.vue";
import Drivers from "./Drivers/ListDrivers/ListDriversPage.vue";
import Coupons from "./Coupons/ListCoupons/ListCouponsPage.vue";
import Limits from "./Limits/ListLimits/ListLimitsPage.vue";
import Clients from "./Users/ListClients/ListClientsPage.vue";
import ScfgUsers from "./SCFG/ListUsers/ListUsersPage.vue";
import Logs from "./Logs/ListLogs/Logs.vue";
import AZK from "./AZK/MainPage.vue";

import { fuelTankService, roleService, fuelDepoService } from "../services";
import { config } from '../config';

import UserSettings from "./UserSettings/UpdateUserSettings/UserSettingsPage.vue";

export default {
  name: "Main",
  components: {
    FuelTanks,
    Reports,
    Charts,
    TaxReports,
    Users,
    UserSettings,
    Drivers,
    Coupons,
    Limits,
    Clients,
    ScfgUsers,
    Logs,
    AZK
  },
  data() {
    return {
      config,
      fuelTanks: null,
      fuelDepos: null,
      isFuelTanksShow: true,
      isFuelReportsShow: false,
      isChartsShow: false,
      isTaxReportsShow: false,
      isUsersShow: false,
      isDriversShow: false,
      isCouponsShow: false,
      isLimitsShow: false,
      isClientsShow: false,
      isScfgUsersShow: false,
      isLogsShow: false,
      isAzkShow: false,
      SUPER_ADMIN_ROLE: roleService.SUPER_ADMIN_ROLE,
      AZK_GET_DATA: roleService.AZK_GET_DATA,
      ADMIN_ROLE: roleService.ADMIN_ROLE,
      FUEL_TANKS_READ_ROLE: roleService.FUEL_TANKS_READ_ROLE,
      REPORTS_READ_ROLE: roleService.REPORTS_READ_ROLE,
      REPORTS_ACCOUNTING_SYSTEM_READ_ROLE:
        roleService.REPORTS_ACCOUNTING_SYSTEM_READ_ROLE,
      CHARTS_READ_ROLE: roleService.CHARTS_READ_ROLE,
      CHARTS_ACCOUNTING_SYSTEM_READ_ROLE:
        roleService.CHARTS_ACCOUNTING_SYSTEM_READ_ROLE,
      TAX_REPORTS_READ_ROLE: roleService.TAX_REPORTS_READ_ROLE,
      CHARTS_LIMITED_READ_ROLE: roleService.CHARTS_LIMITED_READ_ROLE,
      REPORTS_LIMITED_READ_ROLE: roleService.REPORTS_LIMITED_READ_ROLE,
      DRIVERS_READ_ROLE: roleService.DRIVERS_READ_ROLE,
      COUPONS_READ_ROLE: roleService.COUPONS_READ_ROLE,
      LIMITS_READ_ROLE: roleService.LIMITS_READ_ROLE,
      CLIENTS_READ_ROLE: roleService.CLIENTS_READ_ROLE,
      SCFG_USERS_READ_ROLE: roleService.SCFG_USERS_READ_ROLE,
    };
  },
  async created() {
    document.title = config.title;

    const fuelTanksResponse = await fuelTankService.getFuelTanks();

    if (!fuelTanksResponse.isSuccess) {
      //TODO: added error handling
      return;
    }

    this.fuelTanks = fuelTanksResponse.data.fuelTanks;

    this.fuelTanks.sort(function (a, b) {
      const companyNameA = a.companyName.toUpperCase();
      const companyNameB = b.companyName.toUpperCase();

      if (companyNameA != companyNameB) {
        return companyNameA > companyNameB ? 1 : -1;
      }

      const depoNameA = a.depoName.toUpperCase();
      const depoNameB = b.depoName.toUpperCase();

      if (depoNameA != depoNameB) {
        return depoNameA > depoNameB ? 1 : -1;
      }

      const fuelTankNameA = a.fuelTankName.toUpperCase();
      const fuelTankNameB = b.fuelTankName.toUpperCase();

      return fuelTankNameA > fuelTankNameB ? 1 : -1;
    });

    const fuelDeposResponse = await fuelDepoService.getFuelDepos();

    if (fuelDeposResponse.isSuccess) {
      this.fuelDepos = fuelDeposResponse.data.fuelDepos;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/logout", {
        impersonateUser: false
      });
    },
    openUserSettings() {
      this.$refs["user-settings"].open();
    },
    changeLocale(locale) {
      this.$store.dispatch("localization/changeLocale", locale);
    },
    async selectComponent(componentName) {
      if (componentName === "fuelTanks") {
        this.isFuelTanksShow = true;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "reports") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = true;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "charts") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = true;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "taxReports") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = true;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "users") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isDriversShow = false;
        this.isUsersShow = true;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "drivers") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = true;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
        await this.$refs["drivers-page"].init();
      } else if (componentName === "coupons") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = true;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "limits") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = true;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = false;
      } else if (componentName === "clients") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isScfgUsersShow = false;
        this.isClientsShow = true;
        this.isLogsShow = false;
        this.isAzkShow = false;
        await this.$refs["clients-page"].init();
      } else if (componentName === "scfgUsers") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = true;
        this.isLogsShow = false;
        this.isAzkShow = false;
        await this.$refs["scfg-users-page"].init();
      } else if (componentName === "logs") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = true;
        this.isAzkShow = false;
      } else if (componentName === "azk") {
        this.isFuelTanksShow = false;
        this.isFuelReportsShow = false;
        this.isChartsShow = false;
        this.isTaxReportsShow = false;
        this.isUsersShow = false;
        this.isDriversShow = false;
        this.isCouponsShow = false;
        this.isLimitsShow = false;
        this.isClientsShow = false;
        this.isScfgUsersShow = false;
        this.isLogsShow = false;
        this.isAzkShow = true;
      }
    },
  },
};
</script>

<style>
.logo {
  content: " ";
  background: url("../assets/images/logo.png") no-repeat;
  width: 80px;
  height: auto;
  background-size: 100%;
}
</style>

